import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';

export default function StoreSelectionPopup({ open, onClose, onSelect }) {
  const handleSelect = (platform) => {
    if (onSelect) onSelect(platform);
    if (onClose) onClose();
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          key="store-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.45)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999,
          }}
        >
          <motion.div
            key="store-popup"
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 10 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '90%',
              maxWidth: 360,
              backgroundColor: '#ffffff',
              borderRadius: 16,
              padding: '18px 16px 14px',
              boxShadow: '0 12px 30px rgba(0, 0, 0, 0.15)',
            }}
          >
            {/* Header */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 10,
              }}
            >
              <h4
                style={{
                  margin: 0,
                  fontSize: 16,
                  fontWeight: 600,
                }}
              >
                Open app
              </h4>

              <button
                onClick={onClose}
                style={{
                  border: 'none',
                  background: 'transparent',
                  fontSize: 20,
                  cursor: 'pointer',
                  lineHeight: 1,
                }}
              >
                ×
              </button>
            </div>

            {/* Description */}
            <p
              style={{
                margin: '0 0 14px 0',
                fontSize: 13,
                color: '#555',
              }}
            >
              Open FuelClubs in the right app store.
            </p>

            {/* Buttons */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
                marginTop: 4,
              }}
            >
              {/* iOS Button */}
              <button
                onClick={() => handleSelect('ios')}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  borderRadius: 999,
                  border: 'none',
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8,
                  background: 'linear-gradient(135deg, #000000, #333333)',
                  color: '#fff',
                }}
              >
                <AppleIcon fontSize="small" />
                <span>iPhone (App Store)</span>
              </button>

              {/* Android Button */}
              <button
                onClick={() => handleSelect('android')}
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  borderRadius: 999,
                  border: '1px solid #e0e0e0',
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8,
                  backgroundColor: '#f9fafb',
                  color: '#111827',
                }}
              >
                <AndroidIcon fontSize="small" style={{color:"green"}}/>
                <span>Android (Google Play)</span>
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
